const backToTop = document.querySelector(".global-back-to-top")

if (document.querySelector("#FacetFiltersForm")) {
  backToTop.classList.add("above-bottom-bar")
} else if (document.querySelector(".add2Cart_wishlist_wrapper")) {
  backToTop.classList.add("above-pdp-bar")
}

if (
  document.querySelector("#FacetFiltersForm") ||
  document.querySelector(".add2Cart_wishlist_wrapper") ||
  window.location.pathname.startsWith("/collections/")
) {
  backToTop.classList.add("z-4")
}

window.onscroll = function() {
  if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
    backToTop.classList.add("show")
  } else {
    backToTop.classList.remove("show")
  }
}

backToTop.addEventListener("click", function() {
  document.querySelector('body').scrollIntoView({
    behavior: 'smooth',
  })
  document.body.classList.remove("scrolled_down")
  document.body.classList.add("scrolled_up")
})
